/* eslint-disable no-unused-vars*/
import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Form, Input, Row, Switch, Skeleton, DatePicker, Select } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { postCreateTemplateLimit, getTemplateLimitById, putUpdateTemplateLimit } from 'api/templateLimit';
import { getLotteryTypeAll } from 'api/lotteryType';
import { getCookie } from 'helper/cookie';
import Swal from 'sweetalert2';
import { get } from 'lodash';
import { messageRequireIcon } from 'common/messageError/message.common';
export const formatDate = 'YYYY-MM-DDTHH:mm:ssZ';
import { Editor } from '@tinymce/tinymce-react';
import { VITE_REACT_TINY_API_KEY_2 } from 'src/private/config';
import DOMPurify from 'dompurify';

const { Option } = Select;

interface propType {
  id: number;
}

const CreateTemplateLimit = (props: propType) => {
  const { id } = props;
  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const token = getCookie('access_tokenltl');
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLotteryType, setDataLotteryType] = useState<any>([]);
  const [isLoadingDataLotteryType, setIsLoadingDataLotteryType] = useState(false);
  const dataUser: any = getCookie('dataUser');
  const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
  const [lotteryType, setLotteryType] = useState<any>('');
  const [dataTextEditor, setDataTextEditor] = useState('');

  const handleEditorChange = (content: any, editor: any) => {
    // console.log(content)s
    setDataTextEditor(content);
  };

  const fetchLotteryTypeMyData = useCallback(
    async (query: any) => {
      setIsLoadingDataLotteryType(true);
      const params = {
        ids: parseDataUser?.lottery_type,
      };
      try {
        const responseData = await getLotteryTypeAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;

          setDataLotteryType(data?.data?.lottery_type);
          setIsLoadingDataLotteryType(false);
        } else {
          setDataLotteryType('');
          setIsLoadingDataLotteryType(false);
        }
      } catch (error) {
        setIsLoadingDataLotteryType(false);
      }
    },
    [token, id],
  );

  useMemo(() => {
    if (token && parseDataUser) {
      fetchLotteryTypeMyData(parseDataUser?.lottery_type);
    }
  }, [token, id]);

  const fetchTemplateLimitById = useCallback(
    async (query: any) => {
      setIsLoading(true);
      const params = {
        id: id,
      };
      try {
        const responseData = await getTemplateLimitById({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setData(data?.data);
          setIsLoading(false);
          // console.log(dayjs(data?.data?.template_limit_start_date, 'DD/MM/YYYY'))
          // return dayjs(date, 'YYYY/MM/DD');
          // consolemoment(data?.data?.template_limit_start_date).format('DD/MM/YYYY')
          // console.log(data?.data)
          // console.log(moment(data?.data?.template_limit_start_date).format(formatDate))
          form.setFieldsValue({
            template_limit_detail: DOMPurify.sanitize(data?.data?.template_limit_detail),
            lottery_type_id: data?.data?.lottery_type_id,
            owner_id: data?.data?.owner_id,
            group_user_id: data?.data?.group_user_id,
          });
          const sanitizedHTML = DOMPurify.sanitize(data?.data?.template_limit_detail);
          setDataTextEditor(sanitizedHTML);
        } else {
          if (responseData?.status === 404) {
            navigate(`/backoffice/template_limit`, { replace: false });
          }
          setData('');
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    [token, id],
  );

  useMemo(() => {
    if (id && token) {
      fetchTemplateLimitById(id);
    }
  }, [id]);

  const renderRoles = () => {
    if (isLoadingDataLotteryType === false) {
      return dataLotteryType?.map((value: any, index: number) => {
        if (id) {
          if (data?.lottery_type_id === value?.id) {
            return (
              <Option value={value?.id} key={index}>
                {value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)
              </Option>
            );
          }
        } else {
          return (
            <Option value={value?.id} key={index}>
              {value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)
            </Option>
          );
        }
      });
    }
    return [];
  };

  const onChangeValueEditor = (e: any) => {
    // const getContent = e?.level.content
    // setDataTextEditor(getContent);
    // console.log(e)
  };

  const handleSubmit = async (values: any) => {
    const params = {
      lottery_type_id: lotteryType ? lotteryType : Number(data?.lottery_type_id), //values.lottery_type_id ,
      template_limit_detail: DOMPurify.sanitize(dataTextEditor),
    };
    // console.log(dayjs(values.template_limit_end_date, 'YYYY/MM/DD'),)
    // console.log(values?.template_limit_end_date.format('YYYY-MM-DD'))
    // console.log(params)
    if (id) {
      const updateData = await putUpdateTemplateLimit({ token, params: params, id: id });
      if (updateData.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'อัปเดตข้อมูลสำเร็จ',
          showConfirmButton: false,
          timer: 5000,
          showCancelButton: true,
          cancelButtonText: 'ปิด',
        });
        await fetchTemplateLimitById(id);
        navigate(`/backoffice/template_limit`, { replace: true });
      } else {
        Swal.fire({
          icon: 'error',
          title: updateData?.message ? updateData?.message : 'อัปเดตข้อมูลไม่สำเร็จ',
          showConfirmButton: false,
          showCloseButton: true,
        });
      }
    } else {
      const createData = await postCreateTemplateLimit({ token, params: params });
      if (createData.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'บันทึกข้อมูลสำเร็จ',
          showConfirmButton: false,
          timer: 5000,
          showCancelButton: true,
          cancelButtonText: 'ปิด',
        });
        await fetchTemplateLimitById(id);
        navigate(`/backoffice/template_limit`, { replace: true });
        // navigate(`/backoffice/template_limit/edit/${createData?.data?.data?.id}`, { replace: true });
      } else {
        Swal.fire({
          icon: 'error',
          title: createData?.data?.message ? createData?.data?.message : 'บันทึกข้อมูลไม่สำเร็จ',
          showConfirmButton: false,
          timer: 5000,
        });
      }
    }
  };

  return (
    <>
      {isLoading === false ? (
        <Form
          layout="vertical"
          autoComplete="off"
          onFinish={handleSubmit}
          form={form}
          initialValues={{
            lottery_type_id: null,
            template_limit_detail: '',
          }}
        >
          <Row gutter={16} justify="space-between">
            <Col span={isMobileView ? 24 : 24}>
              <Form.Item
                name="lottery_type_id"
                label="ประเภทหวย"
                rules={[
                  {
                    required: true,
                    message: messageRequireIcon('กรุณากรอกข้อมูล ประเภทหวย'),
                  },
                ]}
              >
                <Select
                  placeholder="กรุณาเลือก ประเภทหวย"
                  onChange={(e, option: any) => {
                    setLotteryType(option?.value);
                  }}
                >
                  {renderRoles()}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col span={isMobileView ? 24 :24}>
                     <Form.Item
                        name="template_limit_detail"
                        label="ชื่องวดหวย"
                        rules={[
                           {
                              required: false,
                              message: messageRequireIcon('กรุณากรอกข้อมูล ชื่องวดหวย'),
                           },
                        ]}
                     >
                        <Input type="text" placeholder="ชื่องวดหวย" />
                     </Form.Item>
                  </Col> */}
          </Row>
          <Editor
            id="text-editor"
            apiKey={VITE_REACT_TINY_API_KEY_2}
            init={{
              height: 600,
              menubar: false,
              plugins: ['advlist', 'code', 'autolink', 'lists', 'link', 'image', 'preview', 'visualblocks', 'table'],
              toolbar: [
                'undo redo | fontfamily fontsize | bold italic underline strikethrough formatselect  backcolor | forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | preview code sample | table |SmartCRValue | DatabaseRequestValue',
              ],
              // plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss',
              // toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
              tinycomments_mode: 'embedded',
              tinycomments_author: 'Author name',
              mergetags_list: [
                { value: 'First.Name', title: 'First Name' },
                { value: 'Email', title: 'Email' },
              ],
              ai_request: (request: any, respondWith: any) => respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
            }}
            onChange={e => onChangeValueEditor(e)}
            // initialValue={dataTextEditor}
            onEditorChange={handleEditorChange}
            value={dataTextEditor}
            // onKeyUp={(e) => onChangeValueEditor(e)}
            // initialValue="Welcome to TinyMCE!"
          />
          <div className="clearfix mt-3" />
          <Row>
            <Col span={12}>
              <Link to="/backoffice/template_limit">
                <Button type="text" htmlType="button" size="large" className="btn btn-md btn-secondary">
                  <ArrowLeftOutlined /> ย้อนกลับ
                </Button>
              </Link>
            </Col>
            <Col span={12}>
              <Button type="primary" htmlType="submit" size="large" className="btn btn-md" style={{ float: 'right' }}>
                <SaveOutlined /> {id ? 'อัปเดตข้อมูล' : `เพิ่มข้อมูล`}
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <Skeleton active />
      )}
    </>
  );
};

export default CreateTemplateLimit;
